import React from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IoNotificationsOutline } from "react-icons/io5";
import { RiRobot2Line } from "react-icons/ri";
import { resolvePageMeta } from "./pageMeta";
import { useChat } from "../../../modules/chat/ChatContext";
import { useAiAssistant } from "../../../modules/ai_assistant/AiAssistantContext";
import "./topbar.css";

// Инициалы для кружка-аватара: «Иванов Иван» → «ИИ», «Иван» → «ИВ».
const getInitials = (name) => {
  const parts = String(name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

/**
 * Верхняя панель контента: заголовок страницы, уведомления и текущий пользователь.
 * Без фона и без sticky — обычный поток, прокручивается вместе со страницей.
 */
function Topbar({ client }) {
  const { t } = useTranslation("menu");
  const { t: tAi } = useTranslation("aiAssistant");
  const { pathname } = useLocation();
  const { unread = 0, open: chatOpen, setOpen: setChatOpen } = useChat() || {};
  const { open: aiOpen, setOpen: setAiOpen } = useAiAssistant() || {};
  const user = client?.user || {};
  const isAuthorized = user.id != null;
  const name = user.name || t("user.fallbackName");

  const meta = resolvePageMeta(pathname);
  const title = meta ? t(meta.title) : "";
  const sub = meta ? t(`sub.${meta.sub}`) : "";

  return (
    <header className="topbar container">
      <div className="topbar__titles">
        {title ? <div className="topbar__title">{title}</div> : null}
        {sub ? <div className="topbar__sub">{sub}</div> : null}
      </div>

      <div className="topbar__spacer" />

      {/* Слот для кнопок действий страницы (заполняется через TopbarAction) */}
      <div className="topbar__actions" id="topbar-actions" />

      {/* ИИ помощник: открывает плавающую панель поверх контента */}
      <button
        type="button"
        className={`topbar__ai${aiOpen ? " is-open" : ""}`}
        onClick={() => {
          const next = !aiOpen;
          setAiOpen?.(next);
          if (next) setChatOpen?.(false);
        }}
        aria-pressed={Boolean(aiOpen)}
        title={tAi("title")}>
        <RiRobot2Line size={18} />
        <span className="topbar__ai-text">{tAi("title")}</span>
      </button>

      <button
        type="button"
        className={`icon-btn topbar__bell${unread > 0 ? " has-unread" : ""}${
          chatOpen ? " is-open" : ""
        }`}
        onClick={() => {
          const next = !chatOpen;
          setChatOpen?.(next);
          if (next) setAiOpen?.(false);
        }}
        aria-label={t("user.notifications")}
        title={t("user.notifications")}>
        <IoNotificationsOutline size={19} />
        {unread > 0 ? (
          <span className="icon-btn__count">
            {unread > 99 ? "99+" : unread}
          </span>
        ) : null}
      </button>

      {isAuthorized && (
        <div className="user-chip" title={name}>
          <span className="avatar">{getInitials(name)}</span>
          <span className="user-chip__text">
            <span className="user-chip__name">{name}</span>
            {user.login ? (
              <span className="user-chip__role">{user.login}</span>
            ) : null}
          </span>
        </div>
      )}
    </header>
  );
}

export default Topbar;
